<template>
<div class="chapter">
<div class="inner_page">
      ﻿


<title>The Killing Ship</title>
<link href="../styles/styles.css" rel="stylesheet" type="text/css"/>
<h3 class="FMH2_Front_matter_main_head_2"><em>Titles by Simon Beaufort from Severn House</em></h3>
<p> </p>
<p class="TSR_Teaser_text">THE MURDER HOUSE</p>
<p class="TSR_Teaser_text1">THE KILLING SHIP</p>
<p> </p>
<p class="TSR_Teaser_text1"><em>The Sir Geoffrey Mappestone Series</em></p>
<p class="TSR_Teaser_text">MURDER IN THE HOLY CITY</p>
<p class="TSR_Teaser_text">A HEAD FOR POISONING</p>
<p class="TSR_Teaser_text">THE BISHOP’S BROOD</p>
<p class="TSR_Teaser_text">THE KING’S SPIES</p>
<p class="TSR_Teaser_text">THE COINERS’ QUARREL</p>
<p class="TSR_Teaser_text">DEADLY INHERITANCE</p>
<p class="TSR_Teaser_text">THE BLOODSTAINED THRONE</p>
<p class="TSR_Teaser_text">A DEAD MAN’S SECRET</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// alsoby.vue?06f3cc5c